import BaseServiceCrud from './BaseServiceCrud';

export default class ContactService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'contact';
    }

    getMessages() {
        return this.fetch(`${this.domain}/${this.path}/getContactMessages`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    downloadMessageAttachment(messageId, fileName) {
        return this.fetch(
            `${this.domain}/${this.path}/getContactMessage/${messageId}?file_name=${fileName}`,
            {
                method: 'GET',
            },
            {
                Accept: 'application/octet-stream',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cahce',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    newContactMessage(element) {
        const formData = new FormData();
        if (element.attachment !== null && element.attachment !== undefined) {
            formData.append('file', element.attachment);
            formData.append('file_name', element.attachment.name);
        }
        formData.append('title', element.title);
        formData.append('content', element.content);
        return this.fetch(
            `${this.domain}/${this.path}/newContactMessage`,
            {
                method: 'POST',
                body: formData,
            },
            {
                Accept: 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cahce',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }
}
